<!--开票申请-->
<template>
  <div class="new-application">
    <el-card class="box-card">
      <!-- <div class="back" v-if="isShow">
        <i class="el-icon-back" @click="back"></i>
      </div> -->
      <div class="content-title">
        <span class="title-icon"></span>
        <span class="title-details">基本信息</span>
      </div>
      <div>
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :showBtn="false"
          :showSaveBtn="false"
          :disabled="!isEdit"
          ref="form"
          @cancelForm="cancel"/>
      </div>
      <div class="button">
        <el-button class="btn-cancel" v-if="isEdit" :loading="loading" @click="save(1)" >保存</el-button>
        <el-button class="btn-submit" v-if="isEdit" :loading="loading" @click="submit(2)" >提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
      <drag-dialog :show="stepShow" :title="'审批人选择'" :width="'25%'" @close="close">
        <PersonStep :data="personStepData" @submit="submitConfirm" @close="close"></PersonStep>
      </drag-dialog>
    </el-card>
  </div>
</template>

<script>
import "@/components/dynamic-form";
import { addInvoice, getInvoice, updateInvoice } from "@/api/bill/receipt";
import { getDocumentCode } from "@/views/utils";
import initDict from "@/mixin/initDict";
import CrudMixin from "@/mixins/CrudMixin";
import DragDialog from "@/components/DragDialog"
// import { getFlowNode } from "@/api/hrApproval"
import PersonStep from "@/components/PersonStep";

export default {
  name: "InvoiceForm",
  mixins: [initDict,CrudMixin],
  components: {DragDialog,PersonStep},
  data() {
    return {
      id: "",
      form: { contractId: "" },
      isEdit: false,
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "单据编号",
            value: "",
            span: 8,
            disabled: true
          },
           {
            label: "应收单",
            key: "receivable",
            type: "databox",
            placeholder: "请选择应收单",
            span: 8,
            props: {
              label: "code",
              value: ""
            },
            url: "receivable",
            tableColumn: [
               {
                property: "code",
                label: "编码",
                align: "center",
              },
               {
                property: "paymentDetails",
                label: "签约客户",
                align: "center",
                 query: {
                  type: "input"
                },
                formatter: cur => { return cur ? (cur.contract ? cur.contract.customerSigning.name : '') : '' }
              },
              {
                property: "totals",
                label: "应收金额",
                align: "center",
              },
               {
                property: "moneyId",
                label: "款项说明",
                align: "center",
                // formatter: cur => { this.receipTypes.find(item => item.value === cur.moneyId).label }
                 formatter: cur => { if (cur) { const obj = this.receipTypes.find(item => item.value === cur); return obj.label } }
              },
            ],
            extendParms: { flag: 1 }, // flag 0 查询所有应收单 1 查询未开票的应收单
            multiple: false,
            rules: [
              {
                required: true,
                message: "不能为空",
                trigger: "change"
              }
            ]
          },
          {
            label: "申请人",
            key: "person",
            type: "databox",
            placeholder: "请选择申请人",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bs-person/getList",
            tableColumn: [
               {
                property: "code",
                label: "编码",
                align: "center",
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: [
              {
                required: true,
                message: "不能为空",
                trigger: "change"
              }
            ]
          },
           {
            type: "databox",
            key: "contractObj",
            label: "合同",
            placeholder: "请输入金额",
            value: "",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bizContract",
            tableColumn: [
               {
                property: "id",
                label: "编码",
                align: "center",
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
          },
          {
            label: "金额",
            key: "money",
            type: "input",
            value: "",
            span: 8,
            rules: [
              {
                required: true,
                message: "不能为空",
                trigger: "blur"
              },
              //  {pattern: /^\d+\.?(\d{1,2})?$/,message: '小数点后保留两位',trigger: "blur"}
              {
            validator(rule, value, callback) {
              const reg = /^\d+\.?(\d{1,2})?$/
              if (reg.test(value)) {
                callback();
              } else {
                callback(new Error("小数点后保留两位"));
              }
            },
            trigger: "blur"
            }
            ]
          },
          {
            label: "抬头",
            key: "title",
            type: "input",
            value: "",
            span: 8,
            rules: [
              {
                required: true,
                message: "不能为空",
                trigger: "blur"
              }
            ]
          },
          // {
          //   type: "input",
          //   key: "taxpayer",
          //   label: "纳税人识别号",
          //   value: "",
          //   placeholder: "纳税人识别号",
          //   span: 8,
          //   // rules: [
          //   //   {
          //   //     required: true,
          //   //     message: "不能为空",
          //   //     trigger: "blur"
          //   //   }
          //   // ]
          // },
          //   {
          //   type: "input",
          //   key: "accountBank",
          //   label: "开户银行",
          //   value: "",
          //   span: 8,
          //   // rules: [
          //   //   {
          //   //     required: true,
          //   //     message: "不能为空",
          //   //     trigger: "blur"
          //   //   }
          //   // ]
          // },
          // {
          //   type: "input",
          //   key: "account",
          //   label: "开户行账号",
          //   value: "",
          //   span: 8,
          //   // rules: [
          //   //   {
          //   //     required: true,
          //   //     message: "不能为空",
          //   //     trigger: "blur"
          //   //   }
          //   // ]
          // },
          {
            type: "input",
            key: "content",
            label: "开票内容",
            placeholder: "请输入金额",
            value: "",
            span: 8
          },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            disabled: false,
            value: "",
            placeholder: "请输入备注",
            span: 16,
             maxlength: 200,
          }
        ]
      },
      loading: false,
       validateRefNames: ['form'],
       receipTypes: [], // 收款类型
      form2: {}, // hr审批
      assignData: {}, // hr审批人员信息
      stepShow: false,
      personStepData: []

    };
  },
   watch: {
    'form.receivable': {
      handler(val,oldVal) {
        if (val && !this.id && val !== oldVal) {
          this.form.person = {code: val.paymentDetails.contract.personManage.id, name: val.paymentDetails.contract.personManage.name,id: val.paymentDetails.contract.personManage.id}
          this.form.contractObj = {name: val.paymentDetails.contract.name,id: val.paymentDetails.contract.id}
          this.form.money = val.totals;
          this.form.receivableCode = val.code
          this.form.receivableId = val.id;
          if (this.receipTypes.length > 0) {
            const receipt  = this.receipTypes.find(item => { item.value.toString() === val.moneyId; return item.label })
            this.form.content = receipt.label
          }
          // this.form.content = this.receipTypes.find(item => { item.value.toString() === val.moneyId; return item.label })
        }
      },
      deep: true
    },
    receipTypes: {
      handler(val,oldVal) {
        if (val && val !== oldVal  && !this.id && this.form.receivable) {
          // console.log('val.',val,this.receipTypes)
           if (this.receipTypes.length > 0) {
            const receipt  = this.receipTypes.find(item => { item.value.toString() === this.form.receivable.moneyId; return item.label })
            this.form.content = receipt.label
          }
        }
      }
    }
  },
  created() {
      // 收款类型
      this.getDict("RECEIPT").then(res => {
      this.receipTypes = res.data;
    });
    this.id = this.$route.params.id;
    this.isEdit = this.$route.params.isEdit !== undefined ? Boolean(Number(this.$route.params.isEdit)) : true;
    if (this.id) {
      getInvoice(this.id).then(res => { // 详情
        const form = res.data;
        form.person = {name: form.applyPersonName,code: form.applyPerson,id: form.applyPerson};
        form.contractObj = {name: form.contractName,id: form.contract}
        form.receivable = {code: form.receivableCode,id: form.receivableCode,moneyId: form.receivableEntry ? form.receivableEntry.moneyId : ''}
        this.form = form;
      });
    } else {
       this.form.code = getDocumentCode("KPSQ");
       if (this.$route.query.data) { // 应收单反填
         const data = JSON.parse(this.$route.query.data)
        this.form.person = {code: data.paymentDetails.contract.personManage.id, name: data.paymentDetails.contract.personManage.name,id: data.paymentDetails.contract.personManage.id }
        this.form.contractObj = {name: data.paymentDetails.contract.name,id: data.paymentDetails.contract.id}
        this.form.receivable = {code: data.code,id: data.id,receivedMoney: data.totals,moneyId: data.moneyId,
        paymentDetails: data.paymentDetails,totals: data.totals}
        this.form.money = data.totals;
        this.form.receivableCode = data.code
        this.form.receivableId = data.id;
       }
    }
  },
  methods: {
       close() {
       this.stepShow = false;
      },
     submitConfirm(val) {
      const obj = this.getFormData(2)
      const obj2 = {}
      val.forEach(item => {
        let userList = "";
        item.assignData.forEach(ite => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj2[item.key] = userList;
      });
      obj.assignData = JSON.stringify(obj2)
       obj.from = "moai"
      // console.log('rjuq..',obj)
      this.pull(obj)
    },
    // 提交
    submit(status) {
      this.loading = true
      this._validateForm(this.validateRefNames).then((res) => {
        const obj = this.getFormData(status);
        obj.from = 'moai'
        this.pull(obj);
        //   getFlowNode({ from: "moai", id: this.form.id }).then(res => {
        //        this.loading = false;
        //   this.personStepData = [];
        //   if (res.code === 200) {
        //       this.stepShow = true;
        //       this.personStepData = res.data;
        //   }
        // });
      }).catch(e => { this.loading = false; })
    },
    // 保存
    save(status) {
      this.loading = true;
      // this.getFormData(status)
      this.pull(this.getFormData(status));
    },
    // 组装数据
    getFormData(status) {
        this.form.billState = status;
        console.log(this.form)
      if (this.form.person) {
        this.form.applyPersonName = this.form.person.name;
         this.form.applyPerson = this.form.person.id;
      }
      if (this.form.contractObj) {
        this.form.contractName = this.form.contractObj.name;
        this.form.contract = this.form.contractObj.id;
      }
      const obj = this.form
      return obj
    },
    cancel() {
      this.$store.dispatch('tagsView/delView', this.$route)
      this.$router.go(-1);
    },
    back() {
      this.$router.go(-1);
    },
    pull(obj) {
      if (this.id) {
        updateInvoice(obj).then(res => {
          if (res.code === 200) {
            this.$notify({
              title: "操作成功！",
              type: "success",
              duration: 2500
            });
            this.loading = false
          }
        });
      } else {
        addInvoice(obj).then(res => {
          if (res.code === 200) {
            this.loading = false
            this.$notify({
              title: "操作成功！",
              type: "success",
              duration: 2500
            });
          }
        });
      }
      this.cancel();
    }
  }
};
</script>

<style lang="scss" scoped>
.content-title {
  height: 40px;
  background-color: #e7eff6;
  padding-left: 20px;
  overflow: hidden;
  .title-icon {
    display: inline-block;
    margin-top: 8px;
    width: 4px;
    height: 24px;
    background-color: #1369a8;
    margin-right: 14px;
  }
  .title-details {
    overflow: hidden;
    line-height: 20px;
    display: inline-block;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    font-family: SourceHanSansSC-regular;
  }
}
.el-icon-back {
  padding-bottom: 10px;
}
.button {
      padding-top: 20px;
      text-align: right;

      .btn-submit {
        width: 80px;
        height: 38px;
        background: #1369a8;
        color: white;
      }

      .btn-cancel {
        width: 80px;
        height: 38px;
        background: #fff;
      }
    }
</style>
